import { ENABLE_UPDATED_FAIRE_DIRECT_RELATIONSHIP_CREATION_FLOW_240809 } from "@faire/web-api/indigofair/settings/ENABLE_UPDATED_FAIRE_DIRECT_RELATIONSHIP_CREATION_FLOW_240809";

import { useSetting } from "@faire/retailer/settings/__internal__/useSetting";

export const useSettingFaireDirectRelationshipCreation = () => {
  return useSetting(
    ENABLE_UPDATED_FAIRE_DIRECT_RELATIONSHIP_CREATION_FLOW_240809,
    false
  );
};
